import { render, staticRenderFns } from "./VideoChat.vue?vue&type=template&id=16689a42&scoped=true"
import script from "./VideoChat.vue?vue&type=script&lang=ts"
export * from "./VideoChat.vue?vue&type=script&lang=ts"
import style0 from "./VideoChat.vue?vue&type=style&index=0&id=16689a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16689a42",
  null
  
)

export default component.exports